import Field from "./_Field";

export default class PhoneField extends Field
{

  static findAllFieldsInForm(form){
    const inputsEls = form.querySelectorAll('input[type=tel]');
    const inputs = {};
    for (let el of inputsEls){
      inputs[ el.name ] = el;
    }
    return inputs;
  }

}
